export default "__VITE_ASSET__DTvn6Hmo__"